import React, { useRef } from "react";
import { gsap, useGSAP, EASE } from "../../lib/gsap";

/**
 * Verb 1 of the motion language: mask line-slide.
 * The element rises out of a clipped box as it enters the viewport.
 * Children marked [data-reveal-item] stagger instead of the wrapper moving.
 */
const Reveal = ({
  children,
  as: Tag = "div",
  delay = 0,
  stagger = 0,
  distance = 16,
  start = "top 88%",
  className = "",
  ...rest
}) => {
  const scope = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      const targets = stagger
        ? scope.current.querySelectorAll("[data-reveal-item]")
        : [scope.current];

      if (!targets.length) return;

      mm.add("(prefers-reduced-motion: reduce)", () => {
        gsap.from(targets, {
          opacity: 0,
          duration: 0.4,
          stagger: stagger ? stagger * 0.5 : 0,
          delay,
          scrollTrigger: { trigger: scope.current, start, once: true },
        });
      });

      mm.add("(prefers-reduced-motion: no-preference)", () => {
        // Blocks are uncovered, not floated up: the clip does the work and the
        // small offset only gives it direction.
        gsap.from(targets, {
          y: distance,
          opacity: 0,
          clipPath: "inset(0% 0% 100% 0%)",
          duration: 0.85,
          ease: EASE.out,
          delay,
          stagger,
          scrollTrigger: { trigger: scope.current, start, once: true },
        });
      });

      return () => mm.revert();
    },
    { scope }
  );

  return (
    <Tag ref={scope} className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
